import { render, staticRenderFns } from "./PricesDisplay.vue?vue&type=template&id=24a2e6ed"
import script from "./PricesDisplay.vue?vue&type=script&lang=js"
export * from "./PricesDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports